import ready from 'dom101/ready'
import onmount from 'onmount'

/**
 * Behavior: Wrapping
 */

ready(() => {
  setTimeout(() => { onmount() })
})



// WEBPACK FOOTER //
// ./_js/initializers/onmount.js